'use strict';

import ISiteObjectDto, { ISiteObjectDto_Props } from './SiteObjectDto.if';
import SiteObjectDto from './SiteObjectDto';
import ISiteDto from './SiteDto.if';
import SiteDto from './SiteDto';
import ISiteObjectTypeDto from './SiteObjectTypeDto.if';
import SiteObjectTypeDto from './SiteObjectTypeDto';
import IStyleDto from './StyleDto.if';
import StyleDto from './StyleDto';
import IMediumDto from './MediumDto.if';
import MediumDto from './MediumDto';
import IBeaconSensitivityDto from './BeaconSensitivityDto.if';
import BeaconSensitivityDto from './BeaconSensitivityDto';
import IBeaconDto from './BeaconDto.if';
import BeaconDto from './BeaconDto';
import ISiteObjectTranslationDto from './SiteObjectTranslationDto.if';
import SiteObjectTranslationDto from './SiteObjectTranslationDto';
import ILanguageDto from './LanguageDto.if';
import { IModelSource } from '../interface/db';
import DBUtil from '../private/db.util';

export interface ISiteObjectDto_Linkables {
    site: (db: IModelSource) => Promise<ISiteDto>;
    type: (db: IModelSource) => Promise<ISiteObjectTypeDto>;
    beacon: (db: IModelSource) => Promise<IBeaconDto>;
    beaconSensitivity: (db: IModelSource) => Promise<IBeaconSensitivityDto>;
    nextObject: (db: IModelSource) => Promise<ISiteObjectDto>;
    relatedObject1: (db: IModelSource) => Promise<ISiteObjectDto>;
    relatedObject2: (db: IModelSource) => Promise<ISiteObjectDto>;
    relatedObject3: (db: IModelSource) => Promise<ISiteObjectDto>;
    relatedObject4: (db: IModelSource) => Promise<ISiteObjectDto>;
    relatedObject5: (db: IModelSource) => Promise<ISiteObjectDto>;
    foregroundImageMedium: (db: IModelSource) => Promise<IMediumDto>;
    backgroundImageMedium: (db: IModelSource) => Promise<IMediumDto>;
    menuImageMedium: (db: IModelSource) => Promise<IMediumDto>;
    style: (db: IModelSource) => Promise<IStyleDto>;
    translations: (db: IModelSource) => Promise<ISiteObjectTranslationDto[]>;
    translation: (
        db: IModelSource,
        language: ILanguageDto | number,
    ) => Promise<ISiteObjectTranslationDto>;
    relatedObjects: (db: IModelSource) => Promise<ISiteObjectDto[]>;
}

function _site(this: Partial<ISiteObjectDto_Props>, db: IModelSource): Promise<ISiteDto> {
    return this.siteId
        ? DBUtil.loadSiteId<ISiteDto>(db, this.siteId, SiteDto)
        : Promise.reject('Missing field siteObject.siteId');
}

function _type(this: Partial<ISiteObjectDto_Props>, db: IModelSource): Promise<ISiteObjectTypeDto> {
    return this.siteObjectTypeId
        ? DBUtil.loadSiteObjectTypeId<ISiteObjectTypeDto>(
              db,
              this.siteObjectTypeId,
              SiteObjectTypeDto,
          )
        : Promise.reject('Missing field siteObject.siteObjectTypeId');
}

function _beacon(this: Partial<ISiteObjectDto_Props>, db: IModelSource): Promise<IBeaconDto> {
    return this.beaconId
        ? DBUtil.loadBeaconId<IBeaconDto>(db, this.beaconId, BeaconDto)
        : Promise.reject('Missing field siteObject.beaconId');
}

function _beaconSensitivity(
    this: ISiteObjectDto_Props,
    db: IModelSource,
): Promise<IBeaconSensitivityDto> {
    return this.beaconSensitivityId
        ? DBUtil.loadBeaconSensitivityId<IBeaconSensitivityDto>(
              db,
              this.beaconSensitivityId,
              BeaconSensitivityDto,
          )
        : Promise.reject('Missing field siteObject.beaconSensitivityId');
}

function _nextObject(
    this: Partial<ISiteObjectDto_Props>,
    db: IModelSource,
): Promise<ISiteObjectDto> {
    return this.nextObjectId
        ? DBUtil.loadSiteObjectId<ISiteObjectDto>(db, this.nextObjectId, SiteObjectDto)
        : Promise.reject('Missing field siteObject.nextObjectId');
}

function _relatedObject1(
    this: Partial<ISiteObjectDto_Props>,
    db: IModelSource,
): Promise<ISiteObjectDto> {
    return this.relatedObject1Id
        ? DBUtil.loadSiteObjectId<ISiteObjectDto>(db, this.relatedObject1Id, SiteObjectDto)
        : Promise.reject('Missing field siteObject.relatedObject1Id');
}

function _relatedObject2(
    this: Partial<ISiteObjectDto_Props>,
    db: IModelSource,
): Promise<ISiteObjectDto> {
    return this.relatedObject2Id
        ? DBUtil.loadSiteObjectId<ISiteObjectDto>(db, this.relatedObject2Id, SiteObjectDto)
        : Promise.reject('Missing field siteObject.relatedObject2Id');
}

function _relatedObject3(
    this: Partial<ISiteObjectDto_Props>,
    db: IModelSource,
): Promise<ISiteObjectDto> {
    return this.relatedObject3Id
        ? DBUtil.loadSiteObjectId<ISiteObjectDto>(db, this.relatedObject3Id, SiteObjectDto)
        : Promise.reject('Missing field siteObject.relatedObject3Id');
}

function _relatedObject4(
    this: Partial<ISiteObjectDto_Props>,
    db: IModelSource,
): Promise<ISiteObjectDto> {
    return this.relatedObject4Id
        ? DBUtil.loadSiteObjectId<ISiteObjectDto>(db, this.relatedObject4Id, SiteObjectDto)
        : Promise.reject('Missing field siteObject.relatedObject4Id');
}

function _relatedObject5(
    this: Partial<ISiteObjectDto_Props>,
    db: IModelSource,
): Promise<ISiteObjectDto> {
    return this.relatedObject5Id
        ? DBUtil.loadSiteObjectId<ISiteObjectDto>(db, this.relatedObject5Id, SiteObjectDto)
        : Promise.reject('Missing field siteObject.relatedObject5Id');
}

function _foregroundImageMedium(
    this: Partial<ISiteObjectDto_Props>,
    db: IModelSource,
): Promise<IMediumDto> {
    return this.foregroundImageMediumId
        ? DBUtil.loadMediumId<IMediumDto>(db, this.foregroundImageMediumId, MediumDto)
        : Promise.reject('Missing field siteObject.foregroundImageMediumId');
}

function _backgroundImageMedium(
    this: Partial<ISiteObjectDto_Props>,
    db: IModelSource,
): Promise<IMediumDto> {
    return this.backgroundImageMediumId
        ? DBUtil.loadMediumId<IMediumDto>(db, this.backgroundImageMediumId, MediumDto)
        : Promise.reject('Missing field siteObject.backgroundImageMediumId');
}

function _menuImageMedium(
    this: Partial<ISiteObjectDto_Props>,
    db: IModelSource,
): Promise<IMediumDto> {
    return this.menuImageMediumId
        ? DBUtil.loadMediumId<IMediumDto>(db, this.menuImageMediumId, MediumDto)
        : Promise.reject('Missing field siteObject.menuImageMediumId');
}

function _style(this: Partial<ISiteObjectDto_Props>, db: IModelSource): Promise<IStyleDto> {
    return this.styleId
        ? DBUtil.loadStyleId<IStyleDto>(db, this.styleId, StyleDto)
        : Promise.reject('Missing field siteObject.styleId');
}

function _translations(
    this: Partial<ISiteObjectDto_Props>,
    db: IModelSource,
): Promise<ISiteObjectTranslationDto[]> {
    if (!this.id) {
        return Promise.reject('Missing field siteObject.id');
    }

    const siteObject = this;
    return new Promise((resolve, reject) => {
        DBUtil.allSiteObjectTranslations<ISiteObjectTranslationDto>(db, SiteObjectTranslationDto)
            .then(translations => {
                const match = translations.filter(x => x.siteObjectId === siteObject.id);
                if (match.length > 0) {
                    resolve(match);
                } else {
                    reject('No translations found for siteObjectId:' + siteObject.id);
                }
            })
            .catch((error: Error) => reject(error));
    });
}

function _translation(
    this: Partial<ISiteObjectDto_Props>,
    db: IModelSource,
    language: ILanguageDto | number,
): Promise<ISiteObjectTranslationDto> {
    if (!this.id) {
        return Promise.reject('Missing field siteObject.id');
    }

    const languageId: Number =
        (language as ILanguageDto)?.id != undefined
            ? Number((language as ILanguageDto).id ?? -1)
            : Number(language);

    const siteObject = this;
    return new Promise(function (resolve, reject) {
        _translations
            .call(siteObject, db)
            .then(function (allTranslations: ISiteObjectTranslationDto[]) {
                const match = allTranslations.filter(x => x.languageId === languageId);
                if (match.length > 0) {
                    resolve(match[0]);
                } else {
                    reject(
                        'Unable to find matching translation in siteobject:' +
                            siteObject.id +
                            ', for language:' +
                            languageId,
                    );
                }
            })
            .catch((error: Error) => reject(error));
    });
}

function _relatedObjects(
    this: Partial<ISiteObjectDto_Props>,
    db: IModelSource,
): Promise<Array<ISiteObjectDto>> {
    const siteObject = this;

    return new Promise(async function (resolve, reject) {
        try {
            const promises: Array<Promise<ISiteObjectDto>> = [];

            if (siteObject.relatedObject1Id) {
                promises.push(_relatedObject1.call(siteObject, db));
            }

            if (siteObject.relatedObject2Id) {
                promises.push(_relatedObject2.call(siteObject, db));
            }

            if (siteObject.relatedObject3Id) {
                promises.push(_relatedObject3.call(siteObject, db));
            }

            if (siteObject.relatedObject4Id) {
                promises.push(_relatedObject4.call(siteObject, db));
            }

            if (siteObject.relatedObject5Id) {
                promises.push(_relatedObject5.call(siteObject, db));
            }

            const objects: Array<ISiteObjectDto> =
                promises.length > 0 ? await Promise.all(promises) : [];

            resolve(objects);
        } catch (error) {
            reject(error);
        }
    });
}

/** 
 * @description all custom properties for
   SiteObjectDto & methods to link against other entities
*/
function linkables(model: Partial<ISiteObjectDto_Props>): ISiteObjectDto_Linkables {
    return {
        site: _site.bind(model),
        type: _type.bind(model),
        beacon: _beacon.bind(model),
        beaconSensitivity: _beaconSensitivity.bind(model),
        nextObject: _nextObject.bind(model),
        relatedObject1: _relatedObject1.bind(model),
        relatedObject2: _relatedObject2.bind(model),
        relatedObject3: _relatedObject3.bind(model),
        relatedObject4: _relatedObject4.bind(model),
        relatedObject5: _relatedObject5.bind(model),
        foregroundImageMedium: _foregroundImageMedium.bind(model),
        backgroundImageMedium: _backgroundImageMedium.bind(model),
        menuImageMedium: _menuImageMedium.bind(model),
        style: _style.bind(model),
        translations: _translations.bind(model),
        translation: _translation.bind(model),
        relatedObjects: _relatedObjects.bind(model),
    };
}

export default linkables;
